import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { getTotal } from "../helpers/categories"

const TypeFilters = (props) => (
  <StaticQuery
    query={graphql`
      {
        allSanityTypeCategory {
          edges {
            node {
              slug { current }
              title
              _id
            }
          }
        }
        allSanityResource {
          group(field: category___slug___current) {
            totalCount
            fieldValue
          }
        }
      }
    `}
    render={data => {
      const cats = data.allSanityTypeCategory.edges
      const totals = data.allSanityResource.group

      return (
        <ul data-theme="brandDark" id="categories-list">
          <li>
            <Link to={`/resources/`}>
              All
            </Link>
          </li>
          {cats.map(({node: cat}) =>
            getTotal(cat.slug.current, totals) > 0 ? (
              <li key={cat._id}>
                <Link to={`/resources/${cat.slug.current}/`}>
                  {cat.title} ({getTotal(cat.slug.current, totals)})
                </Link>
              </li>
            ) : null
          )}
        </ul>
      )
    }}
  />
)

export default TypeFilters
